<template>
  <!-- SECCIÓN FOLOVID -->
  <div class="folovid">
    <div class="folovid__fondo">
      <div class="container-fluid folovid__container">
        <div class="row folovid__row justify-content-center">
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-11
              folovid__col folovid__col--titulo
              text-start
              pt-3
              mb-2
            "
          >
            <h1 class="folovid__h1 mb-0" :style="{ color: colorPrimario }">Folovid</h1>
            <router-link
              to="/home"
              class="folovid__link-home"
              aria-label="Acceder a este folovid"
              :style="{ color: colorPrimario }"
            >
              <IconHome  />
              Volver al Home
            </router-link>
            <p class="folovid__subtitulo mt-2">
              ¡Sigamos cuidándonos! Mantén actualizada tu información y accede a
              nuestro reporte de síntomas para ingresar a la compañía.
            </p>
          </div>
        </div>
        <div class="row folovid__row justify-content-center mb-4">
          <div class="col-11">
            <hr class="folovid__hr" />
          </div>
          <div class="col-lg-8 col-md-8 col-12 folovid__col text-start mb-2">
            <p class="folovid__texto folovid__texto--act mb-0">
              Actualizado el
              {{
                new Date().toLocaleString("es-CL", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })
              }}
            </p>
          </div>
          <div
            class="
              col-lg-3 col-md-3 col-11
              folovid__col folovid__col--centrado
              text-end
            "
          >
            <button
              class="folovid__boton boton-pill boton-pill--fondo-lila px-3 py-1"
              data-bs-toggle="modal"
              data-bs-target="#modal-rep-sintomas"
              :style="{ backgroundColor: colorPrimario }"
            >
              Reportar síntomas
            </button>
          </div>
        </div>
        <div class="row folovid__row justify-content-center">
          <div class="col-lg-11 col-md-11 col-sm-11 col-11 folovid__col px-1">
            <div class="row folovid__row" v-if="estadisticas">
              <MisDosis  />
              <EstadoInmunizacion :estadisticas="estadisticas"  />
              <PorcentajeVacunacion :areas_estadisticas="estadisticas.areas_estadisticas" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AÑADIR DOSIS -->
    <ModalAddVacuna />
    <!-- MODAL AÑADIR DOSIS -->

    <!-- MODAL EDITAR DOSIS -->
    <ModalEditVacuna  />
    <!-- MODAL EDITAR DOSIS -->

    <!-- MODAL REPORTAR SÍNTOMAS -->
    <ModalReportarSintomas />
    <!-- MODAL REPORTAR SÍNTOMAS -->

    <!-- MODAL ÉXITO -->
    <div
      class="modal modal-exito fade"
      id="modal-exito"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-exito__dialog modal-dialog-centered">
        <div class="modal-content modal-exito__content-exito">
          <div class="modal-header modal-exito__header pb-0">
            <img
              src="../../../assets/img/intranet/reconocer-colaborador/cara-feliz.svg"
              class="modal-exito__icono-exito"
              alt="Ícono de valor"
            />
            <!-- <button
              type="button"
              class="btn-close modal-exito__btn-cerrar"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button> -->
          </div>
          <div class="modal-body modal-exito__body py-0">
            <div class="container modal-exito__container">
              <div class="row modal-exito__row justify-content-center">
                <div
                  class="
                    col-lg-9 col-md-10 col-11
                    modal-exito__col
                    text-center
                    my-3
                  "
                >
                  <p class="modal-exito__parrafo">
                    Tu dosis ha sido enviada correctamente
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              modal-footer
              modal-exito__footer
              pb-4
              position-relative
              text-center
            "
          >
            <button
              class="modal-exito__btn-finalizar px-4 py-1"
              data-bs-dismiss="modal"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ÉXITO -->

    <!-- MODAL ÉXITO SINTOMAS -->
    <div
      class="modal modal-exito fade"
      id="modal-exito-sintomas"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-exito__dialog modal-dialog-centered">
        <div class="modal-content modal-exito__content-exito">
          <div class="modal-header modal-exito__header pb-0">
            <img
              src="@/assets/img/intranet/reconocer-colaborador/cara-feliz.svg"
              class="modal-exito__icono-exito"
              alt="Ícono de valor"
            />
            <!-- <button
              type="button"
              class="btn-close modal-exito__btn-cerrar"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button> -->
          </div>
          <div class="modal-body modal-exito__body py-0">
            <div class="container modal-exito__container">
              <div class="row modal-exito__row justify-content-center">
                <div
                  class="
                    col-lg-9 col-md-10 col-11
                    modal-exito__col
                    text-center
                    my-3
                  "
                >
                  <p class="modal-exito__parrafo">
                    Tu reporte ha sido generado correctamente
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              modal-footer
              modal-exito__footer
              pb-4
              position-relative
              text-center
            "
          >
            <button
              class="modal-exito__btn-finalizar px-4 py-1"
              data-bs-dismiss="modal"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ÉXITO SINTOMAS -->

    <button
      id="btn-modal-exito"
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modal-exito"
    ></button>

    <button
      id="btn-modal-exito-sintomas"
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modal-exito-sintomas"
    ></button>
  </div>
  <!-- fin SECCIÓN FOLOVID -->
</template>

<script>
// @ is an alias to /src
//import gql from "graphql-tag";

import MisDosis from "@/components/intranet/folovid/MisDosis.vue";
import EstadoInmunizacion from "@/components/intranet/folovid/EstadoInmunizacion.vue";
import PorcentajeVacunacion from "@/components/intranet/folovid/PorcentajeVacunacion.vue";
import ModalAddVacuna from "@/components/intranet/folovid/ModalAddVacuna.vue";
import ModalEditVacuna from "@/components/intranet/folovid/ModalEditVacuna.vue";
import ModalReportarSintomas from "@/components/intranet/folovid/ModalReportarSintomas.vue";
import IconHome from "../../../assets/img/intranet/NavVertical/IconHome.vue";
import { mapState ,mapActions } from "vuex";
export default {
  name: "Folovid",
  data() {
    return {
      estadisticas: null,
    };
  },
  components: {
    MisDosis,
    ModalAddVacuna,
    ModalEditVacuna,
    EstadoInmunizacion,
    PorcentajeVacunacion,
    ModalReportarSintomas,
    IconHome,
  },
  computed:{
      ...mapState("FolovidModule", ["EstadisticasApp"]),
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$root.$on("refresh-dosis", () => {
      this.refreshEstadisticas();
    });
  },
  methods: {
    ...mapActions("FolovidModule", ["getEstadisticaEmpresa"]),

    async getData(){
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk
      }
      await this.getEstadisticaEmpresa(data_).then(res=>{
        if(res){
          this.estadisticas = res;
        }
      });
    },
    refreshEstadisticas() {
      this.$apollo.queries.EstadisticasApp.refetch();
    },
  },
  // apollo: {
  //   EstadisticasApp: {
  //     query: gql`
  //       {
  //         EstadisticasApp(id_empresa: "1") {
  //           total_vacunados
  //           total_usuarios
  //           porcentaje_vacunados
  //           areas_estadisticas {
  //             nombre_area
  //             total_vacunados
  //             total_usuarios
  //             porcentaje_vacunados
  //           }
  //         }
  //       }
  //     `,
  //     result(data) {
  //       this.estadisticas = data.data.EstadisticasApp;
  //     },
  //   },
  // },
};
</script>

